const COMPLETION_STATUS = Object.freeze({
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
});

const normalizeEventId = (eventId) => String(eventId ?? '');

export function markCompletionPending(state, eventId) {
  const normalizedId = normalizeEventId(eventId);
  if (!normalizedId || state[normalizedId] === COMPLETION_STATUS.PENDING) return state;
  return { ...state, [normalizedId]: COMPLETION_STATUS.PENDING };
}

export function markCompletionConfirmed(state, eventId) {
  const normalizedId = normalizeEventId(eventId);
  if (!normalizedId || state[normalizedId] === COMPLETION_STATUS.CONFIRMED) return state;
  return { ...state, [normalizedId]: COMPLETION_STATUS.CONFIRMED };
}

export function removeOptimisticCompletion(state, eventId) {
  const normalizedId = normalizeEventId(eventId);
  if (!normalizedId || !state[normalizedId]) return state;

  const next = { ...state };
  delete next[normalizedId];
  return next;
}

export function reconcileConfirmedCompletions(state) {
  const confirmedIds = Object.keys(state).filter(
    (eventId) => state[eventId] === COMPLETION_STATUS.CONFIRMED
  );
  if (confirmedIds.length === 0) return state;

  const next = { ...state };
  confirmedIds.forEach((eventId) => delete next[eventId]);
  return next;
}

export function applyOptimisticCompletions(events, state) {
  return events.map((event) => (
    state[normalizeEventId(event?.id)]
      ? { ...event, completed: true }
      : event
  ));
}
